import request from "../utils/request";

// https://yapi.gaoding.com/project/1717/interface/api/163868
/**
 * 获取领券详情
 * @returns
 */
export async function getActivity({ activity_code }) {
  return request({
    url: `/biz/activity-info/${activity_code}`,
  });
}

// https://yapi.gaoding.com/project/1717/interface/api/146354
/**
 * 获取领券详情
 * @returns
 */
export async function pickCoupons({ activity_code, coupon_ids }) {
  return request({
    url: "/biz/users/coupons",
    method: "post",
    data: {
      activity_code,
      coupon_ids,
    },
  });
}
